import { Component, Input, OnChanges } from "@angular/core";
import { Chart, registerables } from "chart.js/auto";
import { ObservationResponseAllDto } from "../../../../../common/dtos/observation/observation.response.all";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(...registerables, ChartDataLabels);
@Component({
  selector: "app-pie-chart",
  templateUrl: "./pie-chart.component.html",
  styleUrls: [
    "./pie-chart.component.scss"
  ]
})
export class PieChartComponent implements OnChanges {

  public chart: Chart | null = null;
    @Input() data: ObservationResponseAllDto | undefined;

    ngOnChanges(): void {
      if (this.data) {
        this.createChart(this.data);
      }
    }

    createChart(result: ObservationResponseAllDto) {
      const statusCounts: { [key: string]: number } = {};
      result.content.forEach((item) => {
        let status = item.status_description;
        if(status === "INSERITA") {
          status = "INSERTED";
        }else if(status === "PRESA IN CARICO") {
          status = "ASSIGNED";
        }else if(status === "VERIFICATA") {
          status = "VERIFIED";
        }else if(status === "SCARTATA") {
          status = "DISCARDED";
        }

        if (statusCounts[status!]) {
          statusCounts[status!]++;
        } else {
          statusCounts[status!] = 1;
        }
      });

      const labels = Object.keys(statusCounts);
      const values = Object.values(statusCounts);
      const total = values.reduce((sum, val) => sum + val, 0);

      if (this.chart) this.chart.destroy();

      this.chart = new Chart("PieChart", {
        type: "doughnut",
        data: {
          labels,
          datasets: [
            {
              data: values,
              backgroundColor: [
                "rgb(255, 99, 132)",
                "rgb(54, 162, 235)",
                "rgb(255, 205, 86)",
                "rgb(61, 212, 94)"
              ],
              hoverOffset: 4
            }
          ]
        },
        options: {
          aspectRatio: 2.5,
          plugins: {
            tooltip: {
              callbacks: {
                label(tooltipItem) {
                  const value = tooltipItem.raw as number;
                  const percentage = ((value / total) * 100).toFixed(1);
                  return `${value} (${percentage}%)`;
                }
              }
            }
          }
        }
      });
    }
}
